module.exports = "vPos = (projectionMatrix * modelViewMatrix * vec4(position, 1.0)).xyz;\n\t"